<template>
  <!-- <div class="device-management" id="device-management" :class="active2==1?'active2':'active3'"> -->
  <div class="device-management" id="device-management">
    <div class="device-management-top" id="device-management-top">
      <div class="classification">
        <span :class="active==1?'active':''" @click="btnClick(1)">充电桩</span>
        <span>|</span>
        <span :class="active==2?'active':''" @click="btnClick(2)">边缘主机</span>
        <span>|</span>
        <span :class="active==3?'active':''" @click="btnClick(3)">电表</span>
        <span>|</span>
        <span :class="active==4?'active':''" @click="btnClick(4)">摄像设备</span>
        <span>|</span>
        <span :class="active==5?'active':''" @click="btnClick(5)">桩模板</span>
      </div>
      <div class="management-top-select">
        <el-select v-model="provincesName" clearable placeholder="请选择省" @change="provincesChange">
          <el-option
            v-for="item in provincesList"
            :key="item.province"
            :label="item.province"
            :value="item.province"
          ></el-option>
        </el-select>
        <el-select v-model="cityName" clearable placeholder="请选择市" @change="cityChange">
          <el-option
            v-for="item in cityList"
            :key="item.city"
            :label="item.city"
            :value="item.city"
          ></el-option>
        </el-select>
        <el-select v-model="stationName" clearable placeholder="请选择场站" @change="stationChange">
          <el-option
            v-for="item in stationList"
            :key="item.station_id"
            :label="item.station_name"
            :value="item.station_id"
          ></el-option>
        </el-select>
      </div>
    </div>
    <div class="device-management-table">
      <!-- <div v-if="active==1" :style="{width:clientWidth + 'px'}"> -->
      <div v-if="active==1">
        <charging-pile v-bind:provincesName="provincesName" v-bind:cityName="cityName" v-bind:stationId="stationId" v-on:listenToChildEvent="showMsg"></charging-pile>
      </div>
      <div v-else-if="active==2">
        <edge-host v-bind:provincesName="provincesName" v-bind:cityName="cityName" v-bind:stationId="stationId" v-on:listenToChildEvent="showMsg"></edge-host>
      </div>
      <div v-else-if="active==3">
        <watt-hour-meter v-bind:provincesName="provincesName" v-bind:cityName="cityName" v-bind:stationId="stationId" v-on:listenToChildEvent="showMsg"></watt-hour-meter>
      </div>
      <div v-else-if="active==4">
        <camera-equipment v-bind:provincesName="provincesName" v-bind:cityName="cityName" v-bind:stationId="stationId" v-on:listenToChildEvent="showMsg"></camera-equipment>
      </div>
       <div v-else-if="active==5">
        <PileTemplate v-bind:provincesName="provincesName" v-bind:cityName="cityName" v-bind:stationId="stationId" v-on:listenToChildEvent="showMsg"></PileTemplate>
      </div>
    </div>
  </div>
</template>

<script>
import Bus from '../../assets/js/bus.js'
import ChargingPile from "./chargingPile.vue";
import EdgeHost from "./edgeHost.vue";
import WattHourMeter from "./wattHourMeter.vue";
import CameraEquipment from "./cameraEquipment.vue";
import PileTemplate from "./pileTemplate.vue"
import { constants } from 'fs';
export default {
  data () {
    return {
      provincesList:[],
      provincesName:"",
      cityList:[],
      cityName:"",
      stationList:[],
      stationName:"",
      stationId:"",
      active:1,
      active2:1,
      componentsActive:1,
      iW:"",
      iW2:"",
      message:true,
      clientWidth:"",
    }
  },
  computed:{
     isChangeMsg(){
      //  console.log(this.$store.state.collapse);
       return this.$store.state.collapse;
     }
  },
  mounted() {
    
    this.$nextTick(function() {
      this.getProvince();
    });
  },
  
  beforeRouteEnter(to, from, next) {
    window.document.querySelector("body").setAttribute("style", "background-image:none");
    window.document.body.style.backgroundColor = "#EFEFEF";
    next();
  },
  beforeRouteLeave(to, from, next) {
    window.document.body.style.backgroundColor = "#001928";
    next();
  },
  methods: {
    showMsg(data){
      if(data == "空"){
        this.provincesName = "";
        this.cityName = "";
        this.stationName = "";
        this.cityList = [];
        this.stationList = [];
      }
    },
    getProvince(){
      let params = {
          uid: localStorage.getItem("uid"),
          token: localStorage.getItem("token"),
      };
      this.$api({
          method: "post",
          url: "/api.php/Currency/get_provinces",
          data: params,
          transformRequest: [
          data => {
              let ret = "";
              for (let it in data) {
              ret += encodeURIComponent(it) + "=" + encodeURIComponent(data[it]) + "&";
              }
              return ret;
          }
          ]
      })
          .then(su => {
              if(su.data.code == 1){
                this.provincesList = su.data.list;
              } else if(su.data.code == 300) {
                localStorage.clear(); 
                this.$router.push('/login');
                this.$message.warning(su.data.message);
              } else if (su.data.code == 900)  {
              } else {
                this.$message.warning(su.data.message);
              }
          })
          .catch(err => {
      });
    },
    provincesChange(province){
      // debugger
      this.cityName = "";
      this.cityList = [];
      this.stationName = "";
      this.stationId = "";
      this.stationList = [];
      if(province == ""){
        return
      }
      let params = {
          uid: localStorage.getItem("uid"),
          token: localStorage.getItem("token"),
          province:province,
      };
      this.$api({
          method: "post",
          url: "/api.php/Currency/get_citys",
          data: params,
          transformRequest: [
          data => {
              let ret = "";
              for (let it in data) {
              ret += encodeURIComponent(it) + "=" + encodeURIComponent(data[it]) + "&";
              }
              return ret;
          }
          ]
      })
          .then(su => {
              if(su.data.code == 1){
                  this.cityList = su.data.list;
              } else if(su.data.code == 300) {
                localStorage.clear(); 
                  this.$router.push('/login');
                  this.$message.warning(su.data.message);
              } else if (su.data.code == 900)  {
              } else {
                  this.$message.warning(su.data.message);
              }
          })
          .catch(err => {
      });
    },
    cityChange(city){
      this.stationList = [];
      this.stationName = "";
      this.stationId = "";
      if(city == ""){
        return
      }
      let params = {
          uid: localStorage.getItem("uid"),
          token: localStorage.getItem("token"),
          city:city,
      };
      this.$api({
          method: "post",
          url: "/api.php/Currency/get_stations",
          data: params,
          transformRequest: [
          data => {
              let ret = "";
              for (let it in data) {
              ret += encodeURIComponent(it) + "=" + encodeURIComponent(data[it]) + "&";
              }
              return ret;
          }
          ]
      })
          .then(su => {
              if(su.data.code == 1){
                  this.stationList = su.data.list;
              } else if(su.data.code == 300) {
                localStorage.clear(); 
                  this.$router.push('/login');
                  this.$message.warning(su.data.message);
              } else if (su.data.code == 900)  {
              } else {
                  this.$message.warning(su.data.message);
              }
          })
          .catch(err => {
      });
    },
    stationChange(stationId){
      this.stationId = stationId;
      // console.log(stationId);
      // console.log(this.stationId);
    },
    btnClick(num){
      this.active = num;
      this.active2 = num;
      if(this.active2 !=1){
        document.getElementById("device-management").style.paddingRight = "0%";
      }
    },
  },
  components: {
    ChargingPile,
    EdgeHost,
    WattHourMeter,
    CameraEquipment,
    PileTemplate
  },
}
</script>

<style scoped lang="scss">
.device-management {
  .device-management-top {
    width: 98%;
    height: 60px;
    margin-left: 1%;
    margin-top: 16px;
    background-color: #ffffff;
    text-align: left;
    .classification {
      display: inline-block;
      line-height: 60px;
      margin-left: 1%;
      span {
        margin-right: 20px;
        color: #999999;
        font-size: 16px;
        cursor: pointer;
      }
      span.active {
        color: #0177BD;
        font-weight: 600;
      }
    }
    .management-top-select {
      float: right;
      margin-top: 10px;
      margin-right: 20px;
    }
  }
  .device-management-table {
    width: 98%;
    background-color: #ffffff;
    padding:20px 0;
    margin-left: 1%;
    margin-top: 10px;
  }
}
@media screen and (max-width:1386px) {
  .device-management {
    // padding-right: 5%;
    .device-management-top {
      .management-top-select {
        .el-select {
          width: 150px;
        }
      }
    }
  }
  .device-management.active2 {
    // padding-right: 5%;
  }
  .device-management.active3 {
    // padding-right: 0%;
  }
}
@media screen and (max-width:1260px) {
  .device-management {
    // padding-right: 5%;
    .device-management-top {
      .management-top-select {
        .el-select {
          width: 150px;
        }
      }
    }
  }
  .device-management.active2 {
    // padding-right: 5%;
  }
  .device-management.active3 {
    // padding-right: 0%;
  }
}
</style>
<style lang="scss">
.device-management {
  .el-table td, .el-table th {
    padding: 6px 0 !important;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/stationManagement/deviceManagement.vue